import { createPortal } from "react-dom"
import styled from "styled-components"

import { ApiTypes, UITypes } from "types"

import decodeToMarkDown from "utils/markdown/decodeToMarkDown"
import { ModalLayout } from "layouts/ModalLayout"
import { ModalHeader } from "components/common/ModalHeader"
import Table from "components/table/Table"

const TableContainer = styled.div`
  padding: 15px;
`

// TABLE HEADER
const headerCells: UITypes.TableHeaderCell[] = [
  {
    title: "ID",
    size: "tiny",
    name: "id",
  },
  {
    title: "Title",
    size: "small",
    name: "title",
  },
  {
    title: "Message",
    size: "extra-big",
    name: "message",
    cellComponent: "markdown",
  },
]

interface Props {
  isFetching: boolean
  handleCancelClick: () => void
  messageTemplate?: ApiTypes.Model.MessageTemplate
}

const MessageDrawer = ({ isFetching, handleCancelClick, messageTemplate }: Props) => {
  return (
    <>
      {createPortal(
        <ModalLayout width="770px" onClose={handleCancelClick} isDrawer isWithoutFooter isFetching={isFetching}>
          <ModalHeader title="Scheduled Message" borderless />
          <TableContainer>
            <Table
              headerCells={headerCells}
              isLoading={isFetching}
              data={[
                {
                  id: { value: messageTemplate?.id },
                  title: { value: messageTemplate?.title },
                  message: {
                    value: messageTemplate?.content_rich ? decodeToMarkDown(messageTemplate?.content_rich) : "",
                  },
                  rowSettings: { id: messageTemplate?.id || 0 },
                },
              ]}
            />
          </TableContainer>
        </ModalLayout>,
        document.body,
      )}
    </>
  )
}

// return data?.map(group => ({
//     id: { value: group?.name, groupHeader: true },
//     title: { value: "", hidden: true },
//     message: { value: "", hidden: true },
//     rowSettings: {
//       id: group?.id + 1000,
//       isEnable: false,
//     },
//     subRows:
//       group?.items?.map(items => ({
//         id: { value: items?.id },
//         title: { value: items?.title },
//         message: { value: items?.description_rich ? decodeToMarkDown(items?.description_rich) : "" },
//         rowSettings: {
//           id: items?.id,
//         },
//       })) || [],
//   }))

export default MessageDrawer
